import { render, staticRenderFns } from "./MedtechDashboard.vue?vue&type=template&id=26c1abf6&scoped=true"
import script from "./MedtechDashboard.vue?vue&type=script&lang=js"
export * from "./MedtechDashboard.vue?vue&type=script&lang=js"
import style0 from "./MedtechDashboard.vue?vue&type=style&index=0&id=26c1abf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1abf6",
  null
  
)

export default component.exports